import { Observable } from 'rxjs';
import { inject, Injectable } from '@angular/core';
import { environment } from '@env';
import { HttpClient } from '@angular/common/http';
import { Breakage, BreakageInput } from '../types/breakage.type';

@Injectable()
export class BreakageApiService {
	readonly #httpClient = inject(HttpClient);

	fetchBeakagesForToday(shopId: number): Observable<Breakage[]> {
		const dt = new Date().toISOString().split('T')[0]
		return this.#httpClient.get<Breakage[]>(`${environment.apiUrl}/shops/${shopId}/breakages/${dt}`);
	}

	saveBreakage(shopId: number, breakage: BreakageInput): Observable<Breakage> {
		return this.#httpClient.post<Breakage>(`${environment.apiUrl}/shops/${shopId}/breakages`, breakage);
	}

	removeBreakage(shopId: number, breakageId: number): Observable<any> {
		return this.#httpClient.delete<any>(`${environment.apiUrl}/shops/${shopId}/breakages/${breakageId}`);
	}
}
